import CurrencyRates from '../../../../components/editable-cell/form-items/currency-rate'
import type { ShipmentColumn } from '../../types/column-types'
import { onCellStandard } from '../../helpers/helpers'

export const currencyRateColumn: ShipmentColumn = {
    key: 'currencyRate',
    dataIndex: 'currencyRate',
    title: 'Курс',
    width: 50,
    editable: true,
    FormItem: <CurrencyRates />,
    onCell: onCellStandard,
}
